module.exports = __webpack_public_path__ + "img/亮点.c847d1a9.png";